import 'slick-carousel/slick/slick';

const breakpoints = {
    xlg: 1455,
    lg: 1200,
    md: 992,
    sm: 768,
    xs: 576
};

function cookies(){
    let cookieInfo = $('#cookies-info'),
        cookieClose = cookieInfo.find('.cookies-info__accept');
    checkCookie();

    function setCookie(cname, cvalue, exdays){
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + expires + "; path=/";

    }

    function getCookie(cname){

        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return '';
    }

    function checkCookie(){
        let isExist = getCookie(document.domain + '-cookies-info');
        if (isExist !== '') {
            cookieInfo.hide();
        } else {
            cookieInfo.show();
            cookieClose.on('click', function (e){
                e.preventDefault();
                cookieInfo.hide();
                isExist = true;
                if (isExist !== "" && isExist != null) {
                    setCookie(document.domain + '-cookies-info', isExist, 365);
                }
            });
        }
    }

}

function checkPage(pageClass){
    return document.querySelector('.' + pageClass);
}

function captureHash(){
    if (window.location.hash) {

        const targetDivId = document.querySelector(window.location.hash);

        if (targetDivId) {
            windowScroll(window.location.hash);
        }

        if (targetDivId.tagName !== 'BUTTON' &&
            targetDivId.tagName !== 'A') {
            targetDivId.click();
        }

    }
}

function windowScroll(targetID){
    const elementDiv = document.querySelector(targetID),
        bodyRect = document.body.getBoundingClientRect().top,
        elementRect = elementDiv.getBoundingClientRect().top;

    let elementPosition = elementRect - bodyRect;

    if (checkPage('page-faq') &&
        window.innerWidth < breakpoints.sm) {
        elementPosition = elementPosition - document.querySelector('.page-faq__category').clientHeight;
    }

    setTimeout(() => {
        window.scrollTo({top: elementPosition, behavior: 'smooth'});
    }, 500);

    return elementDiv;
}

function showTooltip(){
    if (checkPage('single-product')) {
        $('.tooltip__show').on('click', function (e){
            $('.tooltip').addClass('show-tooltip');
        });
        $('.single-product').on('click', function (e){
            if ($('.tooltip').hasClass('show-tooltip')) {
                if (!e.target.classList.contains('tooltip-element')) {
                    $('.tooltip').removeClass('show-tooltip');
                }
            }
        });
    }
}

export default {cookies, checkPage, windowScroll, captureHash, breakpoints, showTooltip};



// WEBPACK FOOTER //
// ./src/scripts/functions.js